import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AuthService } from '../services/auth/auth.service';

/**
 * Protects guest-only routes (login, password-forgotten).
 * If the user already has a valid session they are redirected straight
 * to the dashboard — no need to log in again.
 */
export const guestGuard: CanActivateFn = () => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  return auth.isLoggedIn().pipe(
    map(loggedIn => {
      if (!loggedIn) return true;
      return auth.isAdminArea()
        ? router.createUrlTree(['/admin'])
        : router.createUrlTree(['/dashboard']);
    })
  );
};
